import React from 'react';
import { motion } from 'framer-motion';
import { AcademicCapIcon, BeakerIcon, UserGroupIcon, LightBulbIcon } from '@heroicons/react/24/outline';

const ResearchInnovation = () => {
    const fadeInUp = {
        hidden: { opacity: 0, y: 40 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: "easeOut" } }
    };

    return (
        <div className="bg-gray-50 min-h-screen font-sans">
            <section className="relative h-[60vh] min-h-[400px] flex items-center justify-center bg-gray-900 text-white overflow-hidden">
                <motion.div
                    initial={{ scale: 1.1 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 10, repeat: Infinity, repeatType: "reverse" }}
                    className="absolute inset-0 w-full h-full"
                >
                    <div className="absolute inset-0 bg-black/60 z-10"></div>
                    <img
                        src={require('../../../assets/newimages/mas website resarch.webp')}
                        alt="Research"
                        className="w-full h-full object-cover opacity-80"
                    />
                </motion.div>

                <div className="relative z-20 text-center px-4 max-w-5xl mx-auto">
                    <motion.h1
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.2 }}
                        className="text-4xl md:text-6xl font-bold mb-6 leading-tight"
                    >
                        Research & <span className="text-green-400">Innovation Support</span>
                    </motion.h1>
                </div>
            </section>

            <section className="py-20 px-4 md:px-8 max-w-7xl mx-auto">
                <div className="flex flex-col md:flex-row gap-12">
                    <div className="md:w-1/2">
                        <img
                            src={require('../../../assets/newimages/mas website research innovation.webp')}
                            alt="Lab Research"
                            className="rounded-3xl shadow-xl w-full"
                        />
                    </div>
                    <motion.div
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        variants={fadeInUp}
                        className="md:w-1/2"
                    >
                        <h2 className="text-3xl font-bold text-gray-900 mb-6">Bridging Science and Farming</h2>
                        <ul className="space-y-6">
                            <li className="flex gap-4">
                                <AcademicCapIcon className="w-8 h-8 text-green-600 flex-shrink-0" />
                                <div>
                                    <h3 className="font-bold text-lg">New Farming Techniques</h3>
                                    <p className="text-gray-600">Guidance on adopting modern methodologies.</p>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <BeakerIcon className="w-8 h-8 text-green-600 flex-shrink-0" />
                                <div>
                                    <h3 className="font-bold text-lg">Modern Crop Varieties</h3>
                                    <p className="text-gray-600">Access to high-yielding and resilient seeds.</p>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <LightBulbIcon className="w-8 h-8 text-green-600 flex-shrink-0" />
                                <div>
                                    <h3 className="font-bold text-lg">Integrated Management</h3>
                                    <p className="text-gray-600">Nutrient & pest management protocols.</p>
                                </div>
                            </li>
                            <li className="flex gap-4">
                                <UserGroupIcon className="w-8 h-8 text-green-600 flex-shrink-0" />
                                <div>
                                    <h3 className="font-bold text-lg">Expert Collaboration</h3>
                                    <p className="text-gray-600">Partnering with institutions and consultants.</p>
                                </div>
                            </li>
                        </ul>
                    </motion.div>
                </div>
            </section>
        </div>
    );
};

export default ResearchInnovation;
